import { memo, useEffect } from 'react'
import { useLottie } from 'lottie-react'
interface IChildProps {
  loop: boolean
  data: any
  style?: object
}
const Lottie = memo<IChildProps>(props => {
  const { loop, data, style } = props
  const defaultOptions = {
    loop: loop,
    autoplay: true,
    animationData: data,
    // 动画将保持宽高比，并且会在容器内水平和垂直居中显示，可能会裁剪部分内容。
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }
  const { View: lottie, destroy } = useLottie(defaultOptions, style)
  useEffect(() => {
    return () => {
      destroy()
    }
  }, [])

  return lottie
})

export default Lottie
